const platforms = [
  { key: 'kuidare', label: 'Kuidare' },
  { key: 'kiwify', label: 'Kiwify' },
  { key: 'eduzz', label: 'Eduzz' },
  { key: 'hotmart', label: 'Hotmart' },
  { key: 'monetizze', label: 'Monetizze' },
  { key: 'tmb', label: 'TMB Educação' }
];

const platformDefaultIcons = {
  kuidare: require('assets/images/platforms/kuidare.png'),
  kiwify: require('assets/images/platforms/kiwify.png'),
  eduzz: require('assets/images/platforms/eduzz.png'),
  hotmart: require('assets/images/platforms/hotmart.png'),
  monetizze: require('assets/images/platforms/monetizze.png'),
  tmb: require('assets/images/platforms/tmb.png')
};

const platformAltIcons = {
  kuidare: require('assets/images/platforms/kuidare.alt.png'),
  kiwify: require('assets/images/platforms/kiwify.alt.png'),
  eduzz: require('assets/images/platforms/eduzz.alt.png'),
  hotmart: require('assets/images/platforms/hotmart.alt.png'),
  monetizze: require('assets/images/platforms/monetizze.alt.png'),
  tmb: require('assets/images/platforms/tmb.alt.png')
};

const getPlatformLabel = (platform) => {
  return platforms.find((c) => c.key === platform).label;
};

export { platformDefaultIcons, platformAltIcons, platforms, getPlatformLabel };
